import { isRef, Ref, watch, WatchOptions } from '@vue/composition-api';
import { Observable } from 'rxjs';

export function fromRef<T>(
  value: Ref<T>,
  watchOptions?: WatchOptions
): Observable<T> {
  if (isRef<T>(value)) {
    return new Observable((subscriber) => {
      const watchStopHandle = watch(
        value,
        (val) => subscriber.next(val),
        watchOptions
      );

      return () => {
        watchStopHandle();
      };
    });
  }
  throw new Error('value must be a ref, is: ', value);
}
